export const dataToRow = (item) => ({
  id: item.methodCode,
  methodCode: item.methodCode,
})
